import axiosInstance from '../helpers/axios';
import { getToken } from './auth';

// Get annotation
export const getAnnotations = async (idSubBias) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/annotation/?subbias=${idSubBias}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get annotations' info
export const getAnnotationInfo = async (idAnnotation) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/annotation/${idAnnotation}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register annotation
export const registerAnnotation = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/annotation/create/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update annotation
export const updateAnnotation = async (idAnnotation, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/annotation/update/${idAnnotation}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Delete annotation
export const deleteAnnotation = async (idAnnotation, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/bias/annotation/${idAnnotation}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Get annotation counter
export const getAnnotationCounter = (annotations) =>
	annotations?.filter((item) => !item?.is_done)?.length ?? 0;
